<button type="button" class="close" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
</button>  
<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://vimeo.com/event/2685448/embed/6abad08a1a" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>
